webpackJsonp([84],{

/***/ 1362:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_table_run__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_table_run___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_table_run__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_ButtonCreate__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_ButtonCreate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_shared_ButtonCreate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_FilterList__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_FilterList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_shared_FilterList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_mixins__ = __webpack_require__(56);



var loadData = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(page) {
		var url, params, userData;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						url = page === 1 ? 'housemaid' : 'housemaid?page=' + page;
						params = {
							filter_groups: this.filterGroup,
							sort: this.sort
						};
						_context.next = 4;
						return this.$http.get(url, { params: params });

					case 4:
						userData = _context.sent;

						this.rows = userData.data.data;
						this.numberPage = userData.data.last_page;

					case 7:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function loadData(_x) {
		return _ref.apply(this, arguments);
	};
}();

var deleteRow = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4) {
		var id = _ref4.id;
		var url;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						url = 'housemaid/' + id;
						_context2.next = 3;
						return this.$http.delete(url, id);

					case 3:
						this.loadData(this.page);

					case 4:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function deleteRow(_x2) {
		return _ref3.apply(this, arguments);
	};
}();

var updateState = function () {
	var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref6) {
		var id = _ref6.id;
		var newRow;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						newRow = this.rows.filter(function (row) {
							return row.id === id;
						});
						_context3.next = 3;
						return this.$http.put('housemaid/' + id, { flagactive: newRow[0].flagactive });

					case 3:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function updateState(_x3) {
		return _ref5.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







function created() {
	this.loadData(1);
}

function columnSortableEvent(_ref2) {
	var id = _ref2.id;

	var newColumn = this.columns.filter(function (column) {
		return column.id === id;
	});
	newColumn[0].isSortable = newColumn[0].isSortable.down ? { down: false, up: true } : { down: true, up: false };
	var columnName = newColumn[0].code;
	var direction = '';
	if (newColumn[0].isSortable.up) {
		direction = 'ASC';
	} else {
		direction = 'DESC';
	}
	var sort = {
		key: columnName,
		direction: direction
	};
	this.sort[0] = sort;
	this.loadData(1);
}

function selectedFilter(filter) {
	this.filterValue = filter.id;
	var flag = 0;
	if (filter.id === 1) {
		this.filterGroup[0].filters[0] = {};
		this.loadData(1);
	} else {
		flag = filter.id === 2 ? 1 : 0;
		var params = {
			key: 'flagactive',
			value: flag,
			operator: 'eq'
		};
		this.filterGroup[0].filters[0] = params;
		this.loadData(this.page);
	}
}

function editUser(row) {
	this.$router.push({ name: 'users-config', params: { userId: row.id } });
}

function pagesVisible() {
	return this.numberPage < 5 ? this.numberPage : 5;
}

function searchEmployee(search) {
	this.search = search;
	if (search) {
		var params = {
			key: 'name',
			value: search,
			operator: 'ct'
		};
		var paramsLastName = {
			key: 'lastname',
			value: search,
			operator: 'ct'
		};
		var paramsEmail = {
			key: 'email',
			value: search,
			operator: 'ct'
		};
		var paramsFlagActive = {
			key: 'flagactive',
			value: this.filterValue === 2 ? 1 : 0,
			operator: 'eq'
		};
		this.filterGroup = [{
			or: true,
			filters: [params, paramsEmail, paramsLastName]
		}];

		if (this.filterValue !== 1) {
			this.filterGroup[0].filters.push(paramsFlagActive);
		}
		this.loadData(this.page);
	} else {
		this.filterGroup[0].filters[1] = {};
		this.filterGroup[0].filters[1] = {};
		this.filterGroup[0].filters[1] = {};
		this.loadData(1);
	}
}

/* harmony default export */ __webpack_exports__["default"] = ({
	created: created,
	name: 'users-list',
	components: {
		ButtonCreate: __WEBPACK_IMPORTED_MODULE_3__components_shared_ButtonCreate___default.a,
		FilterList: __WEBPACK_IMPORTED_MODULE_4__components_shared_FilterList___default.a,
		TableRun: __WEBPACK_IMPORTED_MODULE_2_table_run___default.a
	},
	computed: {
		pagesVisible: pagesVisible
	},
	data: function data() {
		return {
			href: { name: 'users-new' },
			columns: [{ id: 1, name: 'Nombre', code: 'name', isSortable: { down: true, up: false } }, { id: 2, name: 'Apellidos', code: 'lastname', isSortable: { down: true, up: false } }, { id: 3, name: 'Mail', code: 'email', isSortable: { down: true, up: false } }, { id: 4, name: 'Sucursal', code: 'sucursal_name', isSortable: { down: true, up: false } }, { id: 5, name: 'Cargo', code: 'flag_supervisor', isSortable: { down: true, up: false } }],
			rows: [],
			filterValue: 1,
			page: 1,
			numberPage: 1,
			charge: '',
			search: '',
			filterGroup: [{
				filters: []
			}],
			sort: []
		};
	},

	methods: {
		columnSortableEvent: columnSortableEvent,
		selectedFilter: selectedFilter,
		loadData: loadData,
		editUser: editUser,
		deleteRow: deleteRow,
		searchEmployee: searchEmployee,
		updateState: updateState
	},
	mixins: __WEBPACK_IMPORTED_MODULE_5__shared_mixins__["a" /* default */]
});

/***/ }),

/***/ 1569:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "users"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md10": ""
    }
  }, [_c('filter-list', {
    staticClass: "mb-3",
    attrs: {
      "value": _vm.filterValue
    },
    on: {
      "selected-filter": _vm.selectedFilter
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "md2": ""
    }
  }, [_c('button-create', {
    attrs: {
      "text": 'Usuario',
      "href": _vm.href
    }
  })], 1)], 1), _vm._v(" "), _c('table-run', {
    staticClass: "no-selectable-table",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "selectable": false,
      "include-delete": false,
      "include-export-to-excel": false,
      "include-options": true,
      "include-switch": true,
      "include-settings": true,
      "include-delete-single": true
    },
    on: {
      "go-to-edit-page": _vm.editUser,
      "on-delete-event": _vm.deleteRow,
      "on-sortable-event": _vm.columnSortableEvent,
      "on-search-event": _vm.searchEmployee,
      "on-change-state": _vm.updateState
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.lastname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.sucursal_name))]), _vm._v(" "), (props.row.flag_supervisor > 0) ? _c('td', [_vm._v("Supervisor")]) : _c('td', [_vm._v("Mucama")])]
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-right mt-3"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.numberPage,
      "total-visible": _vm.pagesVisible
    },
    on: {
      "input": function($event) {
        _vm.loadData(_vm.page)
      }
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 863:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1362),
  /* template */
  __webpack_require__(1569),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/84.a58b0e9f5484b2adef31.js